import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * StatGrid — единственный владелец адаптива набора из четырёх счётчиков (`.stat-grid` макета):
 * выше контрольной точки breakpoint — 4 колонки, ниже — 2. Порог — только из токена.
 */
export const StatGrid = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('grid grid-cols-2 gap-3 nw:grid-cols-4', className)} {...props} />
  ),
)
StatGrid.displayName = 'StatGrid'
